import script from "./AppLayoutSidebarNew.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppLayoutSidebarNew.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__